import axios from "axios";
import { apiPath } from "../../constants/config";

let token = localStorage.getItem("accessToken");
let config_headers = {
  headers: {
    Authorization: "Bearer " + token
  }
};

const state = {
  tendersMedias: [],
  orderTypes: [],
  restaurant_qrcode: null
};
const getters = {
  tendersMedias: state => state.tendersMedias,
  orderTypes: state => state.orderTypes,
  restaurant_qrcode: state => state.restaurant_qrcode
};
const mutations = {
  getQrcodeSuccess(state, payload) {
    state.restaurant_qrcode = payload.data;
  }
};

const actions = {
  getTenderMedias({ commit }, payload) {
    return axios.get(`${apiPath}/getTendersMedias/${payload}`).then(r => r);
  },
  getOrderTypes({ commit }, payload) {
    return axios.get(`${apiPath}/getOrderTypes/${payload}`).then(r => r);
  },
  uploadQrCode({ commit }, payload) {
    return axios
      .post(`${apiPath}/qrcode/upload`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        return res;
      });
  },
  createQrCode({ commit }, payload) {
    return axios
      .post(`${apiPath}/qrcode/create`, payload, config_headers)
      .then(r => r)
      .catch(res => {
        return res;
      });
  },
  getLanguesHidden({ commit }, payload) {
    return axios
      .get(`${apiPath}/langues/get`)
      .then(r => r)
      .catch(r => r);
  },
  getQrCode({ commit }, payload) {
    return axios
      .post(`${apiPath}/qrcode/get`, payload, config_headers)
      .then(r => r.data)
      .then(res => {
        commit("getQrcodeSuccess", {
          data: res.data
        });
        return res;
      });
  },

  HasModule({ commit }, payload) {
    let { module, action, pack } = payload;

    let hasModule = pack.modules.find(item => item.module.slug == module);
    if (hasModule) {
      return true;
    } else {
      return false;
    }
  },
  HasPermissionsModule({ commit }, payload) {
    let { module, action, pack } = payload;
    console.log(payload);

    let hasModule = pack.modules.find(item => item.module.slug == module);
    if (hasModule) {
      let hasPermission = hasModule.actions.find(item => item.name == action);
      console.log({ hasPermission, hasModule });
      if (hasPermission) {
        return hasPermission;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
